import { useHistory, useParams } from 'react-router-dom'
import { Row, Tabs } from 'antd'
import AppLayout from '../../../../components/layout/layout'
import { useQueryClient } from '@tanstack/react-query'
import Spinner from '../../../../components/Spinner'
import GuardianBasicInfo from './BasicInformation'
import Header from './Header/Header'
import GuardianEvents from './GuardianEvents'
import Media from './Media'
import { useEffect } from 'react'
import GuardianDocuments from './Documents'
import { forceRefetch } from '../../../../helper/utility'
import Notes from '../NotesComp/Notes'
import { useGetGuardianById } from 'api/family/guardian'
import { guardianStore } from 'state/family/guardian'
import GuardianCreation from '../FamilyProfile/FamilyMembers/Modals/Guardian/GuardianCreation'
import GuardianMedia from './Media'
import { useGetSearchParams } from 'hooks/useGetSearchParams'

const { TabPane } = Tabs
const GuardianProfile = () => {
  const history = useHistory()
  const { id }: { id: string } = useParams()
  const { tab } = useGetSearchParams(['tab'])
  const { data, isLoading, isFetching, refetch } = useGetGuardianById(id)
  const guardianCreationModal = guardianStore(
    store => store.guardianCreationModal,
  )
  const queryClient = useQueryClient()
  const update = () => {
    forceRefetch('getGuardian', queryClient)
    refetch()
  }

  const handleTabChange = (key: string) => {
    if (key === 'events') {
      history.push(`?tab=events&page=1&limit=20`)
    } else {
      history.push(`?tab=${key}`)
    }
  }

  useEffect(() => {
    refetch()
  }, [id])
  return (
    <AppLayout id={id}>
      <div className="container">
        {isLoading || isFetching ? (
          <div className="h-full w-full flex align-center justify-center">
            <Spinner />
          </div>
        ) : (
          <>
            <Header data={data} />
            <Row>
              <Tabs
                activeKey={tab ?? 'basic-info'}
                style={{ width: '100%', height: '100%' }}
                className="bg-white profile-tabs"
                onChange={handleTabChange}
              >
                <TabPane tab="Basic Info" key="basic-info">
                  <GuardianBasicInfo parent={data} refetch={refetch} />
                </TabPane>
                <TabPane tab="Events" key="events">
                  <GuardianEvents id={data.id} />
                </TabPane>
                <TabPane tab="Media" key="media">
                  <GuardianMedia id={data.id} />
                </TabPane>
                <TabPane tab="Documents" key="documents">
                  <GuardianDocuments />
                </TabPane>
                <TabPane tab="Notes" key="notes">
                  <Notes id={id} familyId={data?.familyId} />
                </TabPane>
              </Tabs>
            </Row>
          </>
        )}
      </div>
      {guardianCreationModal && <GuardianCreation familyId="" />}
    </AppLayout>
  )
}
export default GuardianProfile
